import {
    Component,
    ViewEncapsulation,
    ChangeDetectionStrategy,
    Input,
    OnChanges,
} from '@angular/core';

@Component({
    selector: 'mapp-ai-referenced',
    templateUrl: './mercer-ai-referenced.component.html',
    styleUrls: ['./mercer-ai-referenced.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MercerAiReferencedComponent implements OnChanges {
    @Input() isCase1: boolean;

    @Input() sourceData;

    imgArr = [
        '../../../../assets/icons/Profit-Purple.svg',
        '../../../../assets/icons/Briefcase-Purple.svg',
        '../../../../assets/icons/Focus-Purple.svg',
    ];

    /**
     *
     */
    ngOnChanges(): void {
        const result = this.sourceData.map((a) => a.Source);
        this.sourceData = [...new Set(result)];
    }
}
